import React, { memo } from 'react';
import { ReactComponent as Logo } from '@/assets/images/logo/logo-azul.svg';

const Loading = () => {
  return (<Logo className="h-24 max-h-24 bg-indigo-800"/>);
};

export default memo(Loading);
